<template>
  <!-- 公用组件：专题讲座申报-新增-添加学员-->
  <div class="dept">
    <el-input class="search-dept" prefix-icon="el-icon-search" v-model.trim="deptName" @change="searchDep" size="small"
      placeholder="部门名称" />
    <el-checkbox class="checkbox_style" v-model="checkAll" @change="handleCheckAll" v-if="!deptName">全选</el-checkbox>
    <el-tree lazy class="tree-dept" ref="tree" :props="props" :data="treeData" node-key="id" highlight-current
      show-checkbox @check-change="handleCheckChange" :load="loadNode">
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <template v-if="showTooltip">
          <el-tooltip v-if="isSearch" class="item" effect="dark" :content="data.fullName" placement="top-start">
            <span class="ellipsis--l1">{{ data.simpleName || node.label }}</span>
          </el-tooltip>
          <el-tooltip v-else class="item" effect="dark" :content="node.label" placement="top-start">
            <span class="ellipsis--l1">{{ node.label }}</span>
          </el-tooltip>
        </template>
        <span v-else class="ellipsis--l1">{{ node.label }}</span>
      </span>
    </el-tree>
  </div>
</template>

<script>
import { throttle, filterLevelCode } from "@/utils/common.js";
import { lazyTree } from "@/api/dept";
export default {
  props: {
    showTooltip: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      props: {
        label: "name",
        children: "zones",
        isLeaf: function (data, node) {
          return !data.hasChildren
        }
      },
      deptName: "",
      treeData: [],
      checkAll: false,
      isIndeterminate: false,
      flatTreeList: [],
      isSearch: false,
    };
  },
  updated() {
    let doms = document.getElementsByClassName("el-tree-node__label");
    for (let i = 0; i < doms.length; i++) {
      const dom = doms[i];
      dom.title = dom.innerText;
    }
  },
  methods: {
    // 加载节点
    loadNode(node, resolve) {
      let params = {
        parentId: node.data && node.data.id || "",
      }
      lazyTree(params).then(({ code, data }) => {
        if (code !== 0) return;
        this.flatTreeList = this.flatTreeList.concat(data);
        resolve(data);
      });
    },
    handleCheckAll(val) {
      if (val) {
        this.$refs.tree.setCheckedNodes(this.flatTreeList);
      } else {
        this.$refs.tree.setCheckedNodes([]);
      }
    },
    listenCheckAll() {
      let temp = this.$refs.tree.getCheckedNodes();
      this.checkAll = temp.length == this.flatTreeList.length ? true : false;
    },
    // 搜索
    searchDep() {
      this.treeData = [];
      let params = {
        deptName: this.deptName
      }
      this.isSearch = this.deptName && this.deptName.length > 0
      lazyTree(params).then(({ code, data }) => {
        if (code !== 0) return;
        this.treeData = data;
      });
    },
    handleCheckChange: throttle(function () {
      let temp = this.$refs.tree.getCheckedNodes();
      this.listenCheckAll();
      let deptLevelCodes = temp.map(x => x.deptLevelCode);
      let deptParentCodes = filterLevelCode(deptLevelCodes);
      this.$emit("select", { deptLevelCodes: deptParentCodes });
    }, 200),
  },
};
</script>

<style lang="scss" scoped>
.dept {
  .search-dept {
    font-size: 12px;
  }

  /deep/ .el-input__inner::placeholder {
    font-size: 12px;
  }

  .tree-dept {
    margin-top: 10px;
    background-color: #f4f8fb;
    color: #51627d;
    font-size: 12px;
    max-height: 540px;
    overflow: auto;
  }
}

/deep/ .el-tree-node__content {
  height: auto;
}

.checkbox_style {
  margin-top: 12px;
  margin-left: 6px;
}
</style>
